import React from "react";

const CertificationCard = ({ certifications, index }) => {
  return (
    <div key={index} className="p-4 w-full md:w-1/2 lg:w-1/3">
      <div className="bg-background-primary shadow-lg rounded-lg p-6 text-center w-full h-64 flex flex-col justify-center items-center transition-transform transform hover:scale-105">
        <div className="mb-4 flex-shrink-0">
          <img 
            src={certifications.image} 
            alt={certifications.name} 
            className="w-20 h-20 object-contain rounded-md shadow-md"
          />
        </div>
        <h3 className="text-xl font-semibold text-primary mb-2">
          {certifications.name}
        </h3>
        <p className="text-text-primary">{certifications.description}</p>
      </div>
    </div>
  );
};

export default CertificationCard;
